export default __webpack_public_path__ + "static/media/logo-finanzas.ac3eb006.svg";